import styled from "styled-components";
import {
  SocialLinkType,
  TeamCard,
} from "../../../../shared/components/ueber-uns/TeamCard";
import { GridContainer, GridItem } from "../../../../shared/styles/grid/grid";
import { theme } from "../../styles/theme";

const TeamSectionSection = styled.section`
  padding-top: 64px;
  padding-bottom: 64px;
  margin: auto;

  h3 {
    font-size: 48px;
    margin: auto;
    text-align: center;
    margin-top: 0;
    margin-bottom: 32px;
  }
`;
const TeamCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 32px;
  row-gap: 32px;
  align-items: center;
  justify-content: center;
`;

const team = [
  {
    name: "Steven Hille",
    links: [
      {
        type: SocialLinkType.Xing,
        href: "https://www.xing.com/profile/Steven_Hille",
      },
      {
        type: SocialLinkType.LinkedIn,
        href: "https://www.linkedin.com/in/stevenhille/",
      },
      {
        type: SocialLinkType.Email,
        href: "mailto:steven@stellmichein.de",
      },
    ],
    imageSrc: "/images/team/steven.jpg",
  },
  {
    name: "Katharina Kolle",
    links: [
      {
        type: SocialLinkType.Email,
        href: "mailto:hi@stellmichein.de",
      },
      {
        type: SocialLinkType.LinkedIn,
        href: "https://www.linkedin.com/in/katharina-kolle-5b826a246/",
      },
    ],
    imageSrc: "/images/team/katharina.jpg",
  },
  {
    name: "Nico Rohsaint",
    links: [
      {
        type: SocialLinkType.Email,
        href: "mailto:hi@stellmichein.de",
      },
      {
        type: SocialLinkType.LinkedIn,
        href: "https://www.linkedin.com/in/nico-rohsaint-8910a922a/",
      },
    ],
    imageSrc: "/images/team/nico.jpg",
  },
];

export const TeamSection = () => {
  return (
    <TeamSectionSection>
      <h3>Das Team hinter STELL-MICH-EIN</h3>
      <GridContainer>
        <GridItem color={theme.colors.lightBg}>
          <TeamCardContainer>
            {team.map((member) => {
              return (
                <TeamCard
                  key={member.name}
                  name={member.name}
                  links={member.links}
                  imageSrc={member.imageSrc}
                />
              );
            })}
          </TeamCardContainer>
        </GridItem>
      </GridContainer>
    </TeamSectionSection>
  );
};
